// Appended to the WebView user agent by the Fire TV shell (firetv TvConstants.USER_AGENT_MARKER).
// A UI hint only: it decides what the TV shows, never what it may read — the server clamps
// every read to the credential regardless.
export const TV_CLIENT_USER_AGENT_MARKER = 'ys520-tv';

export const isTvClient = (): boolean => navigator.userAgent.includes(TV_CLIENT_USER_AGENT_MARKER);
